import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/5 pt-20 pb-10 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <Logo className="h-10 w-10 object-contain" />
              <span className="text-xl font-bold gold-gradient">PEXADIA</span>
            </Link>
            <p className="text-gray-400 max-w-sm mb-8 text-sm leading-relaxed">
              {t.footer.description}
            </p>
            <div className="flex space-x-4">
              <a href="https://x.com/pexadia" target="_blank" rel="noopener noreferrer" 
                 className="w-10 h-10 glass-card rounded-full flex items-center justify-center hover:text-[#d4af37] transition-colors group"
                 aria-label="Suivre sur X">
                <i className="fab fa-x-twitter group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="https://linkedin.com/company/pexadia" target="_blank" rel="noopener noreferrer"
                 className="w-10 h-10 glass-card rounded-full flex items-center justify-center hover:text-[#d4af37] transition-colors group"
                 aria-label="Suivre sur LinkedIn">
                <i className="fab fa-linkedin-in group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="https://instagram.com/pexadia" target="_blank" rel="noopener noreferrer"
                 className="w-10 h-10 glass-card rounded-full flex items-center justify-center hover:text-[#d4af37] transition-colors group"
                 aria-label="Suivre sur Instagram">
                <i className="fab fa-instagram group-hover:scale-110 transition-transform"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-xs font-black uppercase tracking-widest mb-8 text-gray-500">{t.footer.nav}</h4>
            <ul className="space-y-4 text-gray-400 text-xs font-bold uppercase tracking-widest">
              <li>
                <Link to="/" className="hover:text-[#d4af37] transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[#d4af37] transition-colors">
                  {t.nav.activities}
                </Link>
              </li>
              <li>
                <Link to="/secteurs" className="hover:text-[#d4af37] transition-colors">
                  {t.nav.sectors}
                </Link>
              </li>
              <li>
                <Link to="/workflows" className="hover:text-[#d4af37] transition-colors">
                  {t.nav.workflows}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-[#d4af37] transition-colors">
                  {t.nav.faq}
                </Link>
              </li>
              <li>
                <Link to="/louise-trinit-ia" className="hover:text-[#d4af37] transition-colors">
                  {t.nav.louise}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-xs font-black uppercase tracking-widest mb-8 text-gray-500">{t.footer.legal}</h4>
            <ul className="space-y-4 text-gray-400 text-xs font-bold uppercase tracking-widest">
              <li>
                <a href="#mentions" className="hover:text-[#d4af37] transition-colors">Mentions Légales</a>
              </li>
              <li>
                <a href="#conf" className="hover:text-[#d4af37] transition-colors">Confidentialité</a>
              </li>
              <li>
                <a href="#cgv" className="hover:text-[#d4af37] transition-colors">CGV</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/5 pt-10 text-center">
          <p className="text-gray-500 text-xs uppercase tracking-widest">
            {t.footer.rights} © {currentYear}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

